import {systemConfig} from "@/config/system";

/**
 * 本地存储管理  业务存储
 */

export default class StorageHelp {

  constructor() {
  }

  /*
  *   获取
  * */
  static getStorage(key = '', type) {
    let val = window.localStorage.getItem(key);
    return val && type === "object" ? JSON.parse(val) : val
  }

  /*
  *   设置
  * */
  static setStorage(key = '', val = '', type = 'string') {
    if (!key) {
      throw new Error('没有key值啊')
    }
    type === "object" ?
      window.localStorage.setItem(key, JSON.stringify(val))
      : window.localStorage.setItem(key, val)
  }

  /*
  *   根据key 删除
  * */
  static removeStorage(key = '') {
    if (!key) {
      throw new Error('没有key值啊')
    }
    window.localStorage.removeItem(key)
  }

  /*
  *   清除
  * */
  static clearStorage() {
    window.localStorage.clear()
  }

  /**
   * 获取系统配置 默认三天 如过期 返回 null
   * @return [] or null
   */
  getPlatformConfig() {
    let platformConfigObj = StorageHelp.getStorage(StorageHelp.PLATFORMCONFIG, 'object');
    if (platformConfigObj && (Date.now() - new Date(platformConfigObj.time) < 3 * 24 * 60 * 60 * 1000)) {
      return platformConfigObj.platformConfigMap;
    } else {
      return null;
    }
  }

  /**
   * 储存platformConfigList  储存当前时间用于判断失效
   * @param platformConfigMap
   */
  setPlatformConfigStorage(platformConfigMap) {
    let platformConfig = {
      time: Date.now(),
      platformConfigMap: platformConfigMap
    };
    StorageHelp.setStorage(StorageHelp.PLATFORMCONFIG, platformConfig, 'object');
  }

  /*
  *   清空平台数据
  * */
  cleanPlatformConfigStorage(successFn) {
    StorageHelp.removeStorage(StorageHelp.PLATFORMCONFIG)
  }

  cleanAll(successFn) {
    StorageHelp.clearStorage();
    if (successFn) {
      successFn(res);
    }
  }
}
// 福祉点本地存储
StorageHelp.terminalFzdLocationInfo = '__terminal__fzd_location_info';
/*
*   terminalModuleControl = {
*     outRecord: false,  // 出行记录
*     outRecordCount: false  // 出行统计
*   }
* */
StorageHelp.terminalModuleControl = '__terminal__terminalModuleControl';
//当前类版本
StorageHelp.VERSION = '_fzkVersion_';
StorageHelp.WINDOW_VERSION = '_windowFzkVersion_';
StorageHelp.PLATFORMCONFIG = 'platformConfig';


// 用户信息和 token 信息和卡号
StorageHelp.systemUser = systemConfig.cookiePrefix + 'user';
StorageHelp.systemToken = systemConfig.cookiePrefix + 'token';
StorageHelp.systemPhone = systemConfig.cookiePrefix + 'phone';
StorageHelp.userMenu = systemConfig.cookiePrefix + 'userMenu';
StorageHelp.menuEnum = systemConfig.cookiePrefix + 'menuEnum';
StorageHelp.sysDict = systemConfig.cookiePrefix +'sysDict';
// 记录系统超时时间
StorageHelp.systemZhSystemLongTimerOut = systemConfig.cookiePrefix + 'systemZhSystemLongTimerOut'



// WEBPACK FOOTER //
// ./src/utils/storageHelp.js